import React, { useContext } from 'react'
import { UserContext } from './Main';
import '../css/events.css'
import technical from '../images/aashath.jpg'
import nonTechnical from '../images/pradeep.jpg'
import { Link } from 'react-router-dom';

export default function Events() {

    const value=useContext(UserContext)

    console.log(value);

    return (
        <div className="events">
            <div className="events-title">
                <span>&#47;&#47;</span>Events
            </div>
            <div className="events-type">
                <div className="technical event">
                    <div className="event-title"><span className="pink">#</span>Technical events</div>
                    <div className="event-type-poster">
                        <div className="poster-image">
                            <img src='https://cdn.vectorstock.com/i/preview-1x/76/49/binary-code-digital-technology-background-vector-25687649.jpg' alt={nonTechnical} />
                        </div>
                        <div className="event-description">
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem in expedita vero, est similique nesciunt ex 
                            incidunt, quia quis provident enim eligendi placeat eaque porro quibusdam voluptatibus nisi inventore dolorem 
                            vel nobis magni, reiciendis saepe! Illo laboriosam labore nemo, rerum quod reprehenderit sequi, repellat corruption 
                        </div>
                        <div className="read-more-div">
                            <Link to="technical" className='read-more-btn'>&lt;View More/&gt;</Link>
                        </div>
                    </div>
                </div>
                <div className="non-technical event">
                    <div className="event-title"><span className="pink">#</span>Non Technical events</div>
                    <div className="event-type-poster">
                        <div className="poster-image">
                            <img src='https://th.bing.com/th/id/OIP.2kacIxwJYzQWWMBXs2UXWgAAAA?rs=1&pid=ImgDetMain' alt={technical} />
                        </div>
                        <div className="event-description">
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem in expedita vero, est similique nesciunt ex 
                            incidunt, quia quis provident enim eligendi placeat eaque porro quibusdam voluptatibus nisi inventore dolorem 
                            vel nobis magni, reiciendis saepe! Illo laboriosam labore nemo, rerum quod reprehenderit sequi, repellat corruption 
                        </div>
                        <div className="read-more-div">
                            <Link to="non-technical" className='read-more-btn'>&lt;View More/&gt;</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
}